"use client";

import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
import { useEffect, useRef } from "react";
import { useBotpressWebchat } from "./use-botpress-webchat";

/**
 * Determines the page section based on the current pathname
 */

/**
 * Webchat content component - Uses Next.js Script for simple, robust loading
 */
export function BotpressScripts() {
  const $ = _c(27);
  const {
    isFirstScriptInjected,
    setIsFirstScriptInjected,
    setIsSecondScriptLoaded,
    isSecondScriptLoaded,
    isInitialized,
    setIsInitialized,
    setIsOpen,
    isOpen,
    getUserData
  } = useBotpressWebchat();
  const previousStateRef = useRef(isOpen);
  let t0;
  let t1;
  if ($[0] !== getUserData || $[1] !== isSecondScriptLoaded || $[2] !== setIsInitialized) {
    t0 = () => {
      if (!isSecondScriptLoaded || !window.botpress) {
        return;
      }
      const handleInit = _temp;
      const handleReady = () => {
        console.log("[Botpress] Webchat ready event received");
        const userData = getUserData();
        console.log("[Botpress] Syncing user data on ready:", userData);
        if (window.botpress) {
          window.botpress.updateUser(userData);
        }
        setIsInitialized(true);
      };
      window.botpress.on("webchat:initialized", handleInit);
      window.botpress.on("webchat:ready", handleReady);
    };
    t1 = [isSecondScriptLoaded, setIsInitialized, getUserData];
    $[0] = getUserData;
    $[1] = isSecondScriptLoaded;
    $[2] = setIsInitialized;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[5] !== isInitialized || $[6] !== setIsOpen) {
    t2 = () => {
      if (!isInitialized || !window.botpress) {
        return;
      }
      const checkChatState = _temp2;
      const interval = setInterval(() => {
        const newState = checkChatState();
        if (newState !== previousStateRef.current) {
          previousStateRef.current = newState;
          setIsOpen(newState);
        }
      }, 300);
      const observer = new MutationObserver(() => {
        const newState_0 = checkChatState();
        if (newState_0 !== previousStateRef.current) {
          previousStateRef.current = newState_0;
          setIsOpen(newState_0);
        }
      });
      const fabRoot_0 = document.getElementById("fab-root");
      if (fabRoot_0) {
        observer.observe(fabRoot_0, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ["style", "class"]
        });
      }
      return () => {
        clearInterval(interval);
        observer.disconnect();
      };
    };
    t3 = [isInitialized, setIsOpen];
    $[5] = isInitialized;
    $[6] = setIsOpen;
    $[7] = t2;
    $[8] = t3;
  } else {
    t2 = $[7];
    t3 = $[8];
  }
  useEffect(t2, t3);
  let t4;
  let t5;
  if ($[9] !== getUserData || $[10] !== isInitialized) {
    t4 = () => {
      if (!isInitialized || !window.botpress) {
        return;
      }
      const userData_0 = getUserData();
      console.log("[Botpress] Updating user data:", userData_0);
      window.botpress.updateUser(userData_0);
    };
    t5 = [isInitialized, getUserData];
    $[9] = getUserData;
    $[10] = isInitialized;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[13] !== isInitialized) {
    t6 = () => {
      if (!isInitialized) {
        return;
      }
      const fabRoot_1 = document.getElementById("fab-root");
      if (!fabRoot_1?.shadowRoot) {
        return;
      }
      const isMobile = window.innerWidth < 640;
      if (!isMobile) {
        return;
      }
      if (fabRoot_1.shadowRoot.getElementById("custom-mobile-styles")) {
        return;
      }
      const style_0 = document.createElement("style");
      style_0.id = "custom-mobile-styles";
      style_0.textContent = "\n\t\t\t@media (max-width: 640px) {\n\t\t\t\t.bpWebchat {\n\t\t\t\t\twidth: 100vw !important;\n\t\t\t\t\theight: 100vh !important;\n\t\t\t\t\tmax-width: 100vw !important;\n\t\t\t\t\tmax-height: 100vh !important;\n\t\t\t\t\tborder-radius: 0 !important;\n\t\t\t\t\tleft: 0 !important;\n\t\t\t\t\tright: 0 !important;\n\t\t\t\t\ttop: 0 !important;\n\t\t\t\t\tbottom: 0 !important;\n\t\t\t\t}\n\t\t\t}\n\t\t";
      fabRoot_1.shadowRoot.appendChild(style_0);
    };
    t7 = [isInitialized];
    $[13] = isInitialized;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[16] !== isOpen) {
    t8 = () => {
      const isMobile_0 = window.innerWidth < 640;
      if (isMobile_0) {
        document.documentElement.style.overflow = isOpen ? "hidden" : "";
      }
      return _temp3;
    };
    t9 = [isOpen];
    $[16] = isOpen;
    $[17] = t8;
    $[18] = t9;
  } else {
    t8 = $[17];
    t9 = $[18];
  }
  useEffect(t8, t9);
  let t10;
  if ($[19] !== setIsFirstScriptInjected) {
    t10 = <Script id="botpress-inject" src="https://cdn.botpress.cloud/webchat/v3.5/inject.js" strategy="afterInteractive" onLoad={() => setIsFirstScriptInjected(true)} />;
    $[19] = setIsFirstScriptInjected;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== isFirstScriptInjected || $[22] !== setIsSecondScriptLoaded) {
    t11 = isFirstScriptInjected && <Script id="botpress-config" src="https://files.bpcontent.cloud/2026/01/16/13/20260116130025-JTV8XU38.js" strategy="afterInteractive" onLoad={() => {
      setIsSecondScriptLoaded(true);
    }} />;
    $[21] = isFirstScriptInjected;
    $[22] = setIsSecondScriptLoaded;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <>{t10}{t11}</>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
}
function _temp3() {
  document.documentElement.style.overflow = "";
}
function _temp2() {
  const fabRoot = document.getElementById("fab-root");
  if (!fabRoot?.shadowRoot) {
    return false;
  }
  const webchat = fabRoot.shadowRoot.querySelector(".bpWebchat");
  if (!webchat) {
    return false;
  }
  const style = window.getComputedStyle(webchat);
  const isOpen_0 = style.visibility === "visible" && style.opacity === "1";
  return isOpen_0;
}
function _temp() {
  console.log("[Botpress] Webchat initialized event received");
}